export default __webpack_public_path__ + "static/homebank-ff33e8ea990dcd367f95d8599b69ff85.jpeg";